export default __webpack_public_path__ + "static/media/acmeai.e97bd5e5.svg";